<template>
	<div class="my-item" @click="itemJump(iteminfo)">
		<div class="item-content">
			<section class="template-box">
				<div class="left">
					<template v-if="iteminfo.CardType === 'original'">
						<card-detail  :cardData="iteminfo"></card-detail>
						<div v-if="iteminfo.ProductId == 1 && iteminfo.ExtendData && iteminfo.ExtendData.ShowCardAsList && iteminfo.ExtendData.ShowCardAsList.length > 0">
							<div v-for="(item, idx) in iteminfo.ExtendData.ShowCardAsList" :key="idx">
								<card-detail :cardData="item"></card-detail>
							</div>
					</div>
					</template>
					<normalCard v-else-if="iteminfo.CardType === 'normal'" :order="iteminfo"></normalCard>
					<MultiTrip v-else-if="iteminfo.CardType === 'multiTrip'" :order="iteminfo"></MultiTrip>
				</div>
				<div class="right">
					<div class="price" v-if="iteminfo.ProductId == 613 && iteminfo.ExtendData">
						<span class="price-symbol" v-if="iteminfo.ExtendData.ActCostType != 2">&yen;</span>
						<span class="price-num">{{viewCost(iteminfo.ExtendData.ActCostPrice)}}</span>
					</div>
					<div class="price" v-else-if="iteminfo.ProductId == 47 || iteminfo.ProductId == 34">
						<span class="price-symbol" v-if="iteminfo.CostPrice>0">&yen;</span>
						<span class="price-num" v-if="iteminfo.CostPrice>0">{{viewCost(iteminfo.CostPrice)}}</span>
					</div>
					<div class="price" v-else>
						<template>
							<span class="price-symbol" v-if="(iteminfo.ProductId == 607 && iteminfo.ExtendData) || iteminfo.CostPrice>0">&yen;</span>							
							<span class="price-num" v-if="iteminfo.ProductId == 607 && iteminfo.ExtendData">{{viewCost(iteminfo.ExtendData.ActCostPrice)}}</span>
							<span class="price-num" v-else-if="iteminfo.CostPrice>0">{{viewCost(iteminfo.CostPrice)}}</span>
						</template>
						<div class="member-price" v-if="(iteminfo.ProductId == 1 && iteminfo.ExtendData && iteminfo.ExtendData.IsDHOrder && iteminfo.ExtendData.IsDHOrder == 1)">航司优享价</div>
					</div>
					<div class="status" v-if="!!iteminfo.OrderStatusDesc">{{iteminfo.OrderStatusDesc}}</div>
				</div>
			</section>
			
			
			<div class="orderbtn" v-if="iteminfo.Buttons.length <= 3 && iteminfo.Buttons.length > 0">
				<div class="orderbtns-btn" v-for="(item,index) in iteminfo.Buttons" v-on:click.stop="orderBtnClick(item,iteminfo)" :class="item.Type == 'zhifu' ? 'orange':'default'" :key="index">
					<div>{{item.Title}}</div>
				</div>
			</div>
			<div class="orderbtn-multiple" v-else-if="iteminfo.Buttons.length > 3">
				<div class="more-btn default" @click.stop="moreBtnClick">
					更多
					<div class="more-btn-content" v-if="isShowMore">
						<span class="triangle"><em></em></span>
						<div class="more-item">
							<div v-for="(item, index) in renderBtn" v-if="index < iteminfo.Buttons.length - 2" v-on:click.stop="orderBtnClick(item,iteminfo)" :key="index">{{item.Title}}</div>
						</div>
					</div>
				</div>
				
				<div class="orderbtns-btn" v-for="(item, index) in iteminfo.Buttons" v-if="index >= iteminfo.Buttons.length - 2" v-on:click.stop="orderBtnClick(item,iteminfo)" :class="item.Type == 'zhifu' ? 'orange':'default'" :key="index">
					<div>{{item.Title}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    const sourceType=2
	import {
		order,
		canceldata
	} from '../util/order.js'
	import {
		api,
		devType,
		miniAppVer,
		enterType
	} from '../util/api.js'
	import {
		openUrl,
		getCookie,
		debounce
	} from '../util/tool.js'
	import axios from 'axios'
	import Bus from './bus.js'
	import Toast from './toast/toast.js'
	import CardDetail from '../template/CardDetail'
	import MultiTrip from './multiTrip.vue'
	import normalCard from './normalCard.vue'

	const defaultProjects = [4, 8, 9]
	export default {
		components: {
			CardDetail,
			MultiTrip,
			normalCard
		},
		props: [
			'iteminfo',
			'mainList',
			'itemindex',
			'position',
			'actposition',
			'cancelReasonProjects'
		],
		data() {
			return {
				cancel: {
					showCancel: false,
					couldCancel: false,
					cancelReason: [],
					reason: {},
					card: null,
				},
				clientHeight: document.documentElement.clientHeight + 'px',
				radioSelect: [],
				isShowMore: false,
				btnLoading: false
			}
		},
		watch: {
			actposition(newVal) {
				if(newVal == this.position) return
				this.isShowMore = false
			}
		},
		computed: {
			//按钮超过3个显示更多
			renderBtn: function() {
				return this.iteminfo.Buttons //.slice(3)
			},
			wxJssdk() {
				return this.$root.wxJssdk
			}
		},
		mounted() {
			// 埋点 卡片曝光
			const card = this.iteminfo
			this.$emit("hisTrack", `^卡片曝光^${card.ProductId}^${card.OrderId}^${card.SerialNo}^v2`)
		},
		methods: {
			openUrl(url, wxSDK) {
				if (!url) return
				try {
					if(/^\/page\//ig.test(url)) {
						// 小程序页面
						if (wxSDK) {
							wxSDK.navigateTo({
								url
							})
						}
					} else {
						// H5页面
						const href = url.replace(/^(http:\/\/|https:\/\/|\/\/)((\w|=|\?|\.|\/|&|-)+)/g, 'https://$2')
						window.location.href = href
					}
				} catch (error) {
					console.error('error', error)
				}
			},
			itemJump: debounce(function(info) {				
				console.log('wx.miniProgram', wx, wx.miniProgram,wx.miniProgram.elong_api);
				if (info.DetailFlag) {
					// 判断是H5链接还是原生小程序
					this.openUrl(info.DetailLink, wx.miniProgram)
				} else {
					// 不允许跳转详情页
					this.$toast('如需了解更多，详询95711', 'center', 1000);
				}
				let trackv = `^click^${info.ProductId}^${info.OrderId}^v2`
				this.$emit("hisTrack",trackv)
			},500,true),
			getRemainder: function(date) {
				let time = new Date(date.replace(/\-/igm, '/')).getTime() - new Date().getTime()
				if (isNaN(time) || time < 0) {
					return
				}
				let days = Math.floor(time / (24 * 3600 * 1000)),
					time1 = time % (24 * 3600 * 1000),
					hours = Math.floor(time1 / (3600 * 1000)),
					time2 = time1 % (3600 * 1000),
					minutes = Math.floor(time2 / (60 * 1000)),
					time3 = time2 % (60 * 1000),
					seconds = Math.round(time3 / 1000)

				let str = `${
						days > 0 ? days + '天' : ''
					}${
						hours > 0 ? hours > 9 ? hours + '小时' : hours + '小时' : ''
					}${
						minutes > 0 ? minutes > 9 ? minutes + '分钟' : minutes + '分钟' : ''
					}${
						false ? seconds > 9 ? seconds + '秒' : '0' + seconds + '秒' : ''
					}`.replace(/\s+/g, '');

				return str;
			},
			orderBtnClick(btninfo, iteminfo) {
				if (this.btnLoading) {
					const card = iteminfo
					this.$emit("hisTrack", `^删除中^再次点击，被return^${card.ProductId}^${card.OrderId}^${card.SerialNo}^v2`)
					return
				}
				const btn = btninfo,
					card = iteminfo;
				switch (btn.Type) {																								
					case 'shanchu':
						Bus.$emit('showdialog', {
							title: '删除订单记录不等于取消预订',
							describle: '删除后订单记录无法还原和查询，确定删除吗？',
							iscancel: '点错了',
							istrue: '删除订单',
							callbackf: this.removeOrder.bind(this)
						})
						this.$emit("hisTrack", `^删除model^打开^${card.ProductId}^${card.OrderId}^${card.SerialNo}^v2`)
						break
					case 'shanchuv2':
						Bus.$emit('showdialog', {
							title: '删除订单记录不等于取消预订',
							describle: '删除后订单记录无法还原和查询，确定删除吗？',
							iscancel: '点错了',
							istrue: '删除订单',
							callbackf: this.removeOrderV2.bind(this)
						})
						this.$emit("hisTrack", `^删除model^打开^${card.ProductId}^${card.OrderId}^${card.SerialNo}^v2`)
						break
					default:
						if(btn.ActionUrl) {
							openUrl(btn.ActionUrl, wx.miniProgram)
						}
						break
				}
				this.isShowMore = false
				
			},			
			//删除订单
			removeOrder() {
				this.$emit("toggleOverly", true)
				const card = this.iteminfo
				let me = this;
				let desc = '删除失败，请稍后再试~',
					success = false
				this.$toast('正在删除订单', 'center', 5000);
				
				// 这个的父级控件是scroller.所以两个父级才是列表页
				let wxUser=this.$parent.$parent.getWxUser()
				this.btnLoading = true
				axios.post(api.RemoveHisOrder,Object.assign({
					productId: card.ProductId,					
					serialNo: card.SerialNo,
					OrderId: card.OrderId,						
					miniAppVer: miniAppVer,
					cts: new Date().getTime(),
					devType: devType,						
					OperToken: card.OperToken,
					enterType: enterType,
					sourceType:sourceType					
				},wxUser)).then(res => {					
					if (res.data && res.data.IsSucess) {
						setTimeout(() => {
							me.$toast('删除成功', 'center', 1000);
							me.$emit('deleteItem', {
								orderId: card.OrderId,
								serialNo: card.SerialNo,
								productId: card.ProductId
							})
							this.btnLoading = false
							// 埋点 删除成功
							me.$emit("hisTrack", `^删除结果^接口返回成功^${card.ProductId}^${card.OrderId}^${card.SerialNo}^v2`)
						}, 500);
					} else {
						setTimeout(() => {
							me.$toast('删除失败', 'center', 1000);
							this.btnLoading = false
							// 埋点 删除失败
							me.$emit("hisTrack", `^删除结果^接口返回失败^${card.ProductId}^${card.OrderId}^${card.SerialNo}^v2`)
							this.$emit("toggleOverly", false)
						}, 1000)
					}
				}).catch(error => {
					this.btnLoading = false
					// 埋点 删除失败
					me.$emit("hisTrack", `^删除结果^异常^${JSON.stringify(error)}^${card.ProductId}^${card.OrderId}^${card.SerialNo}^v2`)
					this.$emit("toggleOverly", false)
				})
				let trackv = `^delete^${card.ProductId}^${card.OrderId}^v2`
				me.$emit("hisTrack",trackv)	
			},
			removeOrderV2() {
				this.$emit("toggleOverly", true)
				const card = this.iteminfo
				let me = this;
				this.$toast('正在删除订单', 'center', 5000);
				
				// 这个的父级控件是scroller.所以两个父级才是列表页
				let wxUser=this.$parent.$parent.getWxUser()
				this.btnLoading = true
				axios.post(api.deleteOrder,Object.assign({
					ProductId: card.ProductId,
					OrderSerialId: card.SerialNo,
					OrderId: card.OrderId,
					OperToken: card.OperToken,
					MemberId: card.MemberId,
					enterType: enterType			
				},wxUser)).then(res => {					
					if (res.data && res.data.IsSucess) {
						setTimeout(() => {
							me.$toast('删除成功', 'center', 1000);
							me.$emit('deleteItem', {
								orderId: card.OrderId,
								serialNo: card.SerialNo,
								productId: card.ProductId
							})
							this.btnLoading = false
						}, 500);
					} else {
						setTimeout(() => {
							me.$toast('删除失败', 'center', 1000);
							this.btnLoading = false
							this.$emit("toggleOverly", false)
						}, 1000)
					}
				}).catch(error => {
					this.btnLoading = false
					this.$emit("toggleOverly", false)
				})
				let trackv = `^delete^${card.ProductId}^${card.OrderId}^v2`
				me.$emit("hisTrack",trackv)
			},
			moreBtnClick() {
				this.isShowMore = !this.isShowMore;
				this.$emit('closeMore', {
					actposition: this.position
				})
			},
			viewCost(v){
				var txt = v+'';          
				var index = txt.indexOf(".0")      
				if(index!=-1 && txt.length - index == 2){       
					return txt.substr(0,index);
				}      
				return v
			}					
		}
	}
</script>
<style scoped>
	.template-box {
		display: -webkit-box;
		-webkit-box-pack: justify;
		padding: 5px 15px 0 10px;
	}
	.left {
		-webkit-box-flex: 1;
	}
	.right {
		margin-left: 10px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-align: end;
	}
	.right .price {
		height: 45px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-box-align: end;
		position: relative;
	}
	.right .member-price {
		white-space: nowrap;
		color: #999;
		font-size: 10px;
		text-align: right;
	}
	.right .price-symbol {
		font-size: 12px;
		font-weight: bold;
		color: #ff5346;
	}
	.right .price-num {
		font-size: 16px;
		font-weight: bold;
		color: #ff5346;
	}
	.right .status {
		display: block;
		font-size: 12px;
		color: #333;
	}
	.my-item {
		padding: 0 10px;
	}
	.item-content {
		background: #fff;
		padding-bottom: 18px;
		border-radius: 9px;
		margin: 10px 0;
		text-align: left;
	}
	.titleDesc-box {
		-webkit-box-flex: 1;
	}
	.title-descible {
		width: 100%;
		display: -webkit-box;
		-webkit-box-pack: justify;
	}
	.price-status {
		display: -webkit-box;
		/* autoprefixer: off */
		-webkit-box-orient: vertical;
		/* autoprefixer: on */
		-webkit-box-align: end;
		width: 1.2rem;
		white-space: nowrap;
	}
	.price {
		color: #ff5346;
		height: 0.9rem;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-box-align: end;
	}
	.price-num {
		font-size: 0.32rem;
		font-weight: bold;
		font-family: 'Microsoft YaHei';
	}
	.price-num label {
		font-size: 0.24rem;
		font-weight: bold;
		color: #ff5346;
		font-family: 'Microsoft YaHei';
	}
	.status {
		display: block;
		font-size: 0.24rem;
		color: #333;
	}
	.remainder-time {
		background: #F4F6FA;
		height: 30px;
		line-height: 30px;
		padding-left: 10px;
		box-sizing: border-box;
		border-radius: 5px;
		font-size: 0.26rem;
		margin: 12px 15px 0 45px;
	}
	.remainder-time img {
		width: 0.32rem;
		display: inline-block;
		vertical-align: middle;
	}
	.remainder-time label {
		color: #ff5346;
		display: inline-block;
		vertical-align: middle;
	}
	.remainder-time span {
		display: inline-block;
		vertical-align: middle;
	}
	.orderbtn, .orderbtn-multiple {
		width: 100%;
		box-sizing: border-box;
		margin-top: 0.36rem;
		display: -webkit-box;
		padding-right: 15px;
		padding-bottom: 0;
		-webkit-box-pack: end;
	}
	 .orderbtns-btn {
		margin-left: 10px;
		border-radius: 0.3rem;
		text-decoration: none;
		width: 1.8rem;
		text-align: center;
		font-size: 0.28rem;
		height: 0.6rem;
		display: -webkit-box;
		-webkit-box-pack: center;
		-webkit-box-align: center;
	}
	.orderbtns-btn:first-child {
		margin-left: 0;
	}
	.orderbtns-btn div {
		-webkit-box-flex: 1;
		display: block;
	}
	.default {
		color: #333;
		border: 1px solid rgba(144, 144, 144, 0.5)
	}
	.orange {
		background: -webkit-linear-gradient(#ff6957, #ff5649);
		color: #fff;
	}
	.more-btn {
		border-radius: 0.3rem;
		text-decoration: none;
		width: 1.8rem;
		text-align: center;
		font-size: 0.28rem;
		height: 0.6rem;
		display: -webkit-box;
		-webkit-box-pack: center;
		-webkit-box-align: center;
		position: relative;
	}
	.more-btn label {
		display: inline-block;
		font-size: 15px;
	}
	.more-item {
		border: 1px solid #ccc;
		border-radius: 5px;
	}
	.more-btn-content {
		position: absolute;
		right: 50%;
		transform: translateX(50%);
		top: 38px;
		z-index: 1020;
		margin-top: 6px;
		text-align: center;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-box-align: end;
		background: #fff;
	}
	.more-item div {
		height: 0.6rem;
		line-height: 0.6rem;
		border-bottom: 1px solid #ccc;
		width: 1.4rem;
		margin: 0.05rem 0.2rem;
	}
	.more-item div:last-child {
		border-bottom: none;
	}
	.more-btn-content .triangle {
		display: block;
		width: 0;
		height: 0;
		border-width: 0 6px 6px;
		border-style: solid;
		border-color: transparent transparent #999;
		position: absolute;
		top: -6px;
		left: 50%;
		/* 三角形居中显示 */
		margin-left: -6px;
	}
	.more-btn-content .triangle em {
		display: block;
		width: 0;
		height: 0;
		border-width: 0 10px 10px;
		border-style: solid;
		border-color: transparent transparent #fff;
		position: absolute;
		top: 1px;
		left: -10px;
	}
	.message {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 30px;
		background: #f5f6fa;
		margin: 12px 15px 0 45px;
		border-radius: 5px;
	}
	.message .message-text {
		width: 100%;
		display: inline-block;
		font-size: 13px;
		color: #999;
		padding: 0 10px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
</style>


// WEBPACK FOOTER //
// src/components/hisorderitem.vue